import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Crest } from "@/components/Brand";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const nav = useNavigate();

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
      } catch {}
      if (++tries < 8) setTimeout(poll, 1800);
      else setStatus("pending");
    };
    poll();
  }, [params]);

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, textAlign: "center" }}>
      <div style={{ maxWidth: 420 }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}><Crest size={54} /></div>
        {status === "checking" && <p className="font-serif-c" style={{ fontSize: 30 }}>Confirming your payment…</p>}
        {status === "paid" && <>
          <h1 style={{ fontSize: 44 }}>Payment received</h1>
          <p style={{ color: "var(--muted)", margin: "16px 0 28px" }}>Thank you. Your invoice is now marked as paid in your portal.</p>
        </>}
        {status === "pending" && <p className="font-serif-c" style={{ fontSize: 26 }}>Payment is processing, it may take a moment to reflect.</p>}
        {status === "error" && <p className="font-serif-c" style={{ fontSize: 26 }}>No payment session found.</p>}
        <button className="btn-ink" style={{ marginTop: 20 }} onClick={() => nav("/portal")}>Back to portal</button>
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, textAlign: "center" }}>
      <div style={{ maxWidth: 420 }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}><Crest size={54} /></div>
        <h1 style={{ fontSize: 40 }}>Payment cancelled</h1>
        <p style={{ color: "var(--muted)", margin: "16px 0 28px" }}>No charge was made. You can pay this invoice anytime from your portal.</p>
        <button className="btn-ink" onClick={() => nav("/portal")}>Back to portal</button>
      </div>
    </div>
  );
}
